import ContentLayout from '@/layouts/content-layout'
import RedeemConditionView from '@/sections/privilege/view/redeem-condition-view'

export default function RedeemCondition() {
  return (
    <ContentLayout title="เงื่อนไขการแลก" backButton>
      <RedeemConditionView />
    </ContentLayout>
  )
}
